export const templateEditorPath = '/create/editor?template=';
export const allTemplates = 'All Templates';

export default templateEditorPath;
